/**
 * Created by WebStorm.
 * User: Mehedi Hasan
 * Date: 25 Dec 2024
 * Time: 4:42 PM
 * Email: mdmehedihasanroni28@gmail.com
 */

import React, {createContext, useState} from "react";
import Notification from "../../components/common/Notification";
import {getErrorMessage} from "../../helpers/Utils";
import PMSRoleService from "../../services/pms_services/PMSRoleService";

export const PMSRoleContext = createContext("PMSRoleContext");

const PMSRoleContextProvider = ({children}) => {

    const [errorMsg, setErrorMsg] = useState("");
    const [loading, setLoading] = useState(false);
    const [roleList, setRoleList] = useState([]);

    const [permissionLoading, setPermissionLoading] = useState(false);
    const [permissionList, setPermissionList] = useState([]);

    const getPMSRoleList = async (pharmacyId) => {
        try {

            setLoading(true);
            setErrorMsg("");

            const res = await PMSRoleService.getAllPMSRole(pharmacyId);
            setRoleList(res.data);

            setLoading(false);

            return true;

        } catch (error) {

            setLoading(false);

            let _error = getErrorMessage(error);
            setErrorMsg(_error);
            Notification("error", "ERROR", _error);

            return false;

        }

    }

    const getPMSPermissionList = async () => {
        try {

            setPermissionLoading(true);
            setErrorMsg("");

            const res = await PMSRoleService.getAllPMSPermission();
            setPermissionList(res.data);

            setPermissionLoading(false);

            return res.data;

        } catch (error) {

            setPermissionLoading(false);

            let _error = getErrorMessage(error);
            setErrorMsg(_error);
            Notification("error", "ERROR", _error);

            return null;

        }

    }

    return (
        <PMSRoleContext.Provider
            value={{
                errorMsg,
                loading,
                roleList,
                getPMSRoleList,
                permissionLoading,
                permissionList,
                getPMSPermissionList,
            }}
        >
            {children}
        </PMSRoleContext.Provider>
    )
}

export default PMSRoleContextProvider;
